export const TYPES = "types";
export const SAVE_ACTIVITY = "save_activity";
export const MARK_ATTENDANCE = "mark_attendance";
export const PENDING_ACTIVITY = "pending_activity";
export const IS_CHECKOUT = "is_checkout";
export const SAVE_ACCOUNT = "save_account";
export const TOLL_LIST = "toll_list";
export const TOLL_VIEW = "toll_view";
export const TOLL_FILTER = "toll_filter";
export const APPROVAL_PENDING_LIST = "approval_pending_list";
export const APPROVAL_ACTIVITY = "approval_activity";
export const OPPORTUNITY = "opportunity";
export const SITE_POC_TYPE = "site_poc_type";
export const OEM_MANUFACTURE_NAME = "oem_manufacture_name";
export const ACCOUNT_FILTER = "account_filter";
export const LAST_CHECK_IN = "last_check_in";